function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 32.6879,
  fill: "none",
  "ng-attr-stroke": "{{config.c1}}",
  "ng-attr-stroke-width": "{{config.width}}",
  stroke: "#adc6ff",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  calcMode: "spline",
  values: "0;40",
  keyTimes: "0;1",
  dur: 1.4,
  keySplines: "0 0.2 0.8 1",
  begin: "-0.7s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  values: "1;0",
  keyTimes: "0;1",
  dur: 1.4,
  keySplines: "0.2 0 0.8 1",
  begin: "-0.7s",
  repeatCount: "indefinite"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 12.7871,
  fill: "none",
  "ng-attr-stroke": "{{config.c2}}",
  "ng-attr-stroke-width": "{{config.width}}",
  stroke: "#007AFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  calcMode: "spline",
  values: "0;40",
  keyTimes: "0;1",
  dur: 1.4,
  keySplines: "0 0.2 0.8 1",
  begin: "0s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  values: "1;0",
  keyTimes: "0;1",
  dur: 1.4,
  keySplines: "0.2 0 0.8 1",
  begin: "0s",
  repeatCount: "indefinite"
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ripple",
    style: {
      background: "none"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.8f7faefb.svg";
export { ForwardRef as ReactComponent };